import { render } from "./VaBeneCampagneListPage.vue?vue&type=template&id=76ab25f2&ts=true"
import script from "./VaBeneCampagneListPage.vue?vue&type=script&lang=ts"
export * from "./VaBeneCampagneListPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__